<template>
    <div class="ffq__success">
        <img :src="headerSvgPath" :class="headerSvgCss" />
        <div class="ffq__success__inner px-10 pb-10">
            <h3 class="leading-11 mb-7 ">{{ completedSubmission.success_title }}</h3>
            <div class="email-user">
                {{ completedSubmission.email }}
            </div>
            <p class="text-sm leading-6 mt-6 mb-7">
                {{ $t('U ontvangt de email binnen 5 minuten, heeft u de mail niet ontvangen? Controleer dan ook uw spam-box.')}}
            </p>
            <button class="ffq-button" @click="closeDialog()">{{ $t('Venster sluiten') }}</button>
        </div>
    </div>
</template>
<style lang="scss">
.ffq__success{
    @apply max-w-full;
    //max-width: 896px;
    text-align: center;
    padding: 25px 0 0 0;
    .email-user {
        font-size: 24px;
    }
    &__inner {
        h3{
            @apply text-2xl;
            @media(min-width: 1024px){
                @apply text-4xl;
            }
        }
        .text-sm {
            max-width: 438px;
            margin-left: auto;
            margin-right: auto;
        }
        .email-user {
            @apply font-semibold  flex flex-col items-center justify-center rounded-full italic; //xl:h-20 h-12
            @apply p-5;
            @apply h-auto;
            @apply break-all;
            //font-size: 24px;
            font-size: 12px;
            background-color:#ccefe8;
            color: rgba(0, 136, 127, 0.6);

            @screen sm{
                font-size: 16px;
            }
            @screen md{
                font-size: 18px;
            }
            @screen lg{
                font-size: 24px;
            }
        }
    }
}
.ffq-button{
    @apply font-bold text-white py-4 px-5;
    background:var(--color-primary-light);
    border-radius: 0 25px 0 25px;

    &:hover{
        background:var(--color-primary);
    }
}
</style>
<script>
import { useStore } from 'vuex'
import {computed} from 'vue'
import BrowserVersionHelper from "../../Helpers/BrowserVersionHelper";

export default {
    name: "FinishScreen",
    components:{

    },
    data() {

    },
    mounted() {

    },
    computed:{
        headerSvgPath(){
            // Use animated svg for chrome only
            if((new BrowserVersionHelper()).isChrome()){
                return '/plugins/wallbrinkcrossmedia/flitzfunnelquizzes/assets/images/icon-send-centered-animated-v2b.svg?v=1';
            }
            return '/plugins/wallbrinkcrossmedia/flitzfunnelquizzes/assets/images/icon-send.svg?v=1';
        },
        headerSvgCss(){
            if((new BrowserVersionHelper()).isChrome()){
                return [];
            }
            // Use animate.css for non-chrome browsers
            return ['animated', 'fadeIn'];
        }
    },
    setup(props){
        const store = useStore()

        return {
            completedSubmission: computed(() => store.state.completedSubmission),
            closeDialog: () => { store.commit('closeDialog');}
        }
    },
    methods:{

    },
    props: {

    }
}
</script>
